import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Checkbox, Form, Table } from 'semantic-ui-react';
import EditBudgetCodeRow from './edit-budget-code-row.js';
import { trackInterfaceSelectAllForBudgetCodeAssignment } from '../../lib/analytics.js';
import { submitProductRequisitionBudgetCode } from '../../actions/requisition-actions.js';
import { openCustomerBudgetCodeCreateModal } from '../../actions/customer-budget-codes-actions.js';
import 'semantic-ui-css/components/checkbox.min.css';
import 'semantic-ui-css/components/form.min.css';
import 'semantic-ui-css/components/table.min.css';
import './edit-budget-code-products.css';

export class EditProductRequisitionsBudgetCodes extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedProductRequisitions: [],
      sortedProductRequisitions: props.productRequisitions.sort(sorter),
      selectOptions: props.customerBudgetCodes
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((c) => {
          return { key: c.id, value: c.id, text: `${c.name}` };
        }),
    };
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState(() => {
      return {
        sortedProductRequisitions: nextProps.productRequisitions.sort(sorter),
        selectOptions: nextProps.customerBudgetCodes
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((c) => {
            return { key: c.id, value: c.id, text: `${c.name}` };
          }),
      };
    });
  };

  isSelectDisabled = () => {
    return this.state.selectedProductRequisitions.length < 1;
  };

  onChangeSelect = (e, { value }) => {
    if (!value) {
      return;
    }
    this.state.selectedProductRequisitions.map((p) => {
      return this.props.actions.submitProductRequisitionBudgetCode({
        id: p.id,
        customer_budget_code_id: value,
      });
    });
  };

  onCheckAll = (e, { checked }) => {
    trackInterfaceSelectAllForBudgetCodeAssignment();
    if (checked) {
      this.setState((prev) => {
        return {
          selectedProductRequisitions: prev.sortedProductRequisitions,
        };
      });
      return;
    }
    this.setState(() => {
      return {
        selectedProductRequisitions: [],
      };
    });
  };

  onCheckProductRequisition = (item, selected) => {
    if (selected) {
      this.setState((prev) => {
        return {
          selectedProductRequisitions:
            prev.selectedProductRequisitions.concat(item),
        };
      });
      return;
    }
    this.setState((prev) => {
      return {
        selectedProductRequisitions: prev.selectedProductRequisitions.filter(
          (l) => l.id !== item.id
        ),
      };
    });
  };

  handleOpenCreateModal = () => {
    if (!this.props.can_manage_billing) {
      return;
    }
    this.props.actions.openCustomerBudgetCodeCreateModal();
  };

  onChangeRowCustomerBudgetCode = (row, cbc) => {
    this.props.actions.submitProductRequisitionBudgetCode({
      id: row.id,
      customer_budget_code_id: cbc.id,
    });
  };

  renderProductRequisition = (item) => {
    const isChecked =
      this.state.selectedProductRequisitions.filter((l) => l.id === item.id)
        .length > 0;
    return (
      <EditBudgetCodeRow
        key={item.id}
        item={item}
        isChecked={isChecked}
        onChangeCustomerBudgetCode={this.onChangeRowCustomerBudgetCode}
        onSelect={this.onCheckProductRequisition}
      />
    );
  };

  render() {
    return (
      <div className="edit-budget-code-products">
        <Form>
          <Form.Group>
            <Form.Field width={4}>
              <p className="instructions gray-text">
                Select products to bulk-assign them to a category.
              </p>
            </Form.Field>
            <Form.Dropdown
              placeholder="Select Category"
              width={7}
              selection
              clearable
              onChange={this.onChangeSelect}
              options={this.state.selectOptions}
            />
            {this.props.can_manage_billing && (
              <Form.Button
                secondary
                width={7}
                size="small"
                compact
                onClick={this.handleOpenCreateModal}
              >
                Create New Category
              </Form.Button>
            )}
          </Form.Group>
        </Form>
        <Table basic>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="2">
                <Checkbox
                  style={{ fontSize: '1em' }}
                  label="All Items"
                  checked={
                    this.state.selectedProductRequisitions.length ===
                    this.state.sortedProductRequisitions.length
                  }
                  name="select-all"
                  onChange={this.onCheckAll}
                />
              </Table.HeaderCell>
              <Table.HeaderCell>Category</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {(this.state.sortedProductRequisitions || []).map(
              this.renderProductRequisition
            )}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

const productProp = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});
const budgetCodeProp = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

function sorter(a, b) {
  if (a.customer_budget_code.id === b.customer_budget_code.id) {
    return a.created_at > b.created_at ? 1 : -1;
  }
  return a.customer_budget_code.id > b.customer_budget_code.id ? 1 : -1;
}
const filterActiveBudgetCodes = (c) => {
  return c.active;
};

EditProductRequisitionsBudgetCodes.propTypes = {
  productRequisitions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      product: productProp.isRequired,
      customer_budget_code: budgetCodeProp,
    })
  ).isRequired,
  customerBudgetCodes: PropTypes.arrayOf(budgetCodeProp).isRequired,
  can_manage_billing: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submitProductRequisitionBudgetCode: PropTypes.func.isRequired,
    openCustomerBudgetCodeCreateModal: PropTypes.func.isRequired,
  }).isRequired,
};

export function mapStateToProps(state) {
  return {
    customerBudgetCodes: state.customerBudgetCodes.items.filter(
      filterActiveBudgetCodes
    ),
    can_manage_billing: state.auth.role.can_manage_billing,
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        submitProductRequisitionBudgetCode,
        openCustomerBudgetCodeCreateModal,
      },
      dispatch
    ),
  };
}
function areStatesEqual(prev, next) {
  return (
    prev.customerBudgetCodes.items === next.customerBudgetCodes.items &&
    prev.auth.role === next.auth.role &&
    prev.requisitions.open === next.requisitions.open
  );
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
  areStatesEqual,
})(EditProductRequisitionsBudgetCodes);
